import { range } from 'lodash';

export const getListYears = (startYear: number, endYear: number) => {
  return range(startYear, endYear + 1);
};
